<template>
    <div>
        <div class="yellow-btn radio" style="text-align: left">
            <i class="iconfont iconxiazai"></i>
            <a :href="todownStc" style="color: #fff;" target="_blank">下载文件</a>
        </div>
        <div
            v-if="fileNameHz === 'doc' ||fileNameHz === 'docx'  ||fileNameHz === 'xls' ||fileNameHz === 'xlsx' ||fileNameHz === 'ppt'||fileNameHz === 'pptx'"
            class="other-set"
        >
            <i class="iconfont iconbanbenxinjian"></i>
            <a
                :href="'https://view.officeapps.live.com/op/view.aspx?src=' + todownStc"
                style="color: #0a2240;"
                target="_blank"
            >在线预览</a>
        </div>

        <div v-else-if="fileNameHz === 'pdf'||fileNameHz === 'mp4' ||fileNameHz === 'ogv'" class="other-set" @click="showFile">
            <i class="iconfont iconbanbenxinjian"></i>
            在线预览
        </div>
<!--        <template v-if="isEdit">-->
<!--            <div class="other-set" @click="editFile">-->
<!--                <i class="el-icon-edit"></i>-->
<!--                在线编辑-->
<!--            </div>-->
<!--        </template>-->


        <div class="other-set" @click="uploadDia = true">
            <i class="iconfont iconshangchuan"></i>上传新版本
            <!--      <el-upload-->
            <!--        style="position:absolute;top: 0;left: 0;width: 100%;height: 100%;"-->
            <!--        :action="domain"-->
            <!--        :data="QiniuData"-->
            <!--        :on-error="uploadError"-->
            <!--        :on-success="uploadSuccess"-->
            <!--        :before-upload="beforeAvatarUpload"-->
            <!--        :show-file-list="false"-->
            <!--        multiple-->
            <!--        :file-list="fileList"-->
            <!--      ></el-upload>-->
        </div>
        <div v-if="oldList.length>0" class="other-set" @click="dialogVisible = true">
            <i class="iconfont iconbanbenxinjian"></i>历史版本
        </div>
        <div class="other-set" @click="DelFolder">
            <i class="iconfont iconshanchu"></i>删除当前文档
        </div>
        <!-- 点击历史弹出 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" title="历史版本" width="40%">
            <ul class="old-list">
                <li v-for="(item,index) in oldList" :key="index">
                    <span>历史上传时间：{{ item.addtime }}</span>
                    <span>历史上传人：{{ item.lastuname }}</span>
                    <br/>
                    <div class="file-name">
                        <a :href="item.filepath" target="_blank">历史版本：{{ item.label }}(点击下载)</a>
                        <a
                            v-if="item.label.substr(item.label.lastIndexOf('.')+1) === 'doc' ||
                 item.label.substr(item.label.lastIndexOf('.')+1) === 'docx'  ||
                 item.label.substr(item.label.lastIndexOf('.')+1) === 'xls' ||
                 item.label.substr(item.label.lastIndexOf('.')+1) === 'xlsx' ||
                 item.label.substr(item.label.lastIndexOf('.')+1) === 'ppt'||
                 item.label.substr(item.label.lastIndexOf('.')+1) === 'pptx'"
                            :href="'https://view.officeapps.live.com/op/view.aspx?src=' + item.filepath"
                            target="_blank"
                        >查看</a>
                        <a
                            v-if="item.label.substr(item.label.lastIndexOf('.')+1) === 'pdf'"
                            :href="item.filepath"
                            target="_blank"
                        >查看</a>
                    </div>
                </li>
            </ul>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
        </el-dialog>


        <upLoadFileOne
            :uploadDia="uploadDia"
            @syncFile="syncFile"
        ></upLoadFileOne>
    </div>
</template>

<script>
import {genUpToken} from "../../tools/CryptoJS";
import upLoadFileOne from "@/views/components/upLoadFileOne";
import {edit_files} from "@/tools";

export default {
    name: "rightSet",
    //  上传新版本的话 上传回调需要加一个参数 f_id,
    data() {
        return {
            uploadDia: false,
            todownStc: "", //  下载地址
            fileNameHz: "", //  文件后缀
            oldList: [], //  旧版次
            oldList2: [],
            QiniuData: {
                fname: "", //  文件名
                key: "", //文件名字处理
                token: "" //七牛云token
            },
            domain: "https://upload-z2.qiniup.com/", // 七牛云的上传地址（华南区）
            qiniuaddr: "https://img.emof.cn", // 七牛云的图片外链地址 你的七牛云里配置有
            uploadPicUrl: "", //提交到后台图片地址
            fileList: [],
            nowTime: "",
            fileExtension: "",
            dialogVisible: false // 历史版本mode
        };
    },
    props: {
        downStc: {
            type: String,
            default: ""
        },
        old: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    computed:{
        isEdit() {
            return edit_files.filter(f=>{
                return f.types.includes(this.fileNameHz)
            }).length > 0
        }
    },
    components: {
        upLoadFileOne
    },
    created() {
        this.fileNameHz = this.$route.query.name.split(".").pop();
        this.todownStc = this.downStc;
        this.oldList = this.old;
        this.nowTime = this.getDate();
        var token;
        var policy = {};
        var bucketName = "zhishiguanli"; //你的七牛桶名称
        var AK = "_MhT6BWLiDGy2755HTwoxzNH747ecCtlqldVq3p3"; //你的七牛AK
        var SK = "15juIkGIozY13PvocO4o5lckBFb-OzqFrSVAAM7z"; //你的七牛SK
        var deadline = Math.round(new Date().getTime() / 1000) + 3600;
        policy.scope = bucketName;
        policy.deadline = deadline;
        token = genUpToken(AK, SK, policy);
        this.QiniuData.token = token;
        console.log(this.fileNameHz);
    },
    methods: {
        syncFile() {
            this.uploadDia = false
            this.$emit('isAdd')
        },
        //  单个删除
        DelFolder() {
            this.$confirm("此操作将删除该文件至回收站, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.$api.apiContent
                        .DelFolder({
                            mid: this.$store.state.userMid,
                            username: this.$store.state.userName,
                            ids: [this.$route.query.cid]
                        })
                        .then(res => {
                            this.$message.success(res.msg);
                            this.$store.state.upTree = true;
                            window.history.go(-1);
                        })
                        .catch(e => {
                            this.$message.error(e.msg);
                        });
                })
                .catch();
        },
        showFile() {
            console.log(this.todownStc);
            window.open(this.todownStc);
        },
        //  上传前判断
        beforeAvatarUpload(file) {
            //这里的key给加上了时间戳，目的是为了防止上传冲突
            this.QiniuData.fname = file.name;
            this.QiniuData.key = `${this.nowTime}${file.name}`;
            this.loading = this.$loading({
                lock: true,
                text: "上传中，请稍后",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        //  上传成功
        uploadSuccess(response, file, fileList) {
            console.log(file);
            console.log(fileList);
            this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
            console.log(this.uploadPicUrl);
            //在这里你就可以获取到上传到七牛的外链URL了
            this.$api.apiContent
                .addFile({
                    f_id: this.$route.query.cid,
                    mid: this.$store.state.userMid,
                    // folderid:this.$route.query.cid,
                    label: file.name,
                    filesize: file.size,
                    kid: this.$route.query.id,
                    savename: response.key,
                    username: this.$store.state.userName,
                    filetype: file.name.split(".").pop()
                })
                .then(() => {
                    this.loading.close();
                    this.$message.success("上传成功");
                    this.$emit("isAdd");
                })
                .catch(e => {
                    this.$message.error(e.msg);
                });
        },
        //  上传失败
        uploadError(err, file, fileList) {
            console.log(err);
            console.log(file);
            console.log(fileList);
            this.loading.close();
            this.$message({
                message: "上传出错，请重试！",
                type: "error",
                center: true
            });
        },

        //以下是时间戳函数
        getDate() {
            var myDate = new Date();
            //获取当前年
            var year = myDate.getFullYear();
            //获取当前月
            var month = myDate.getMonth() + 1;
            //获取当前日
            var date = myDate.getDate();
            var h = myDate.getHours(); //获取当前小时数(0-23)
            var m = myDate.getMinutes(); //获取当前分钟数(0-59)
            var s = myDate.getSeconds();
            //获取当前时间
            var now =
                year +
                this.conver(month) +
                this.conver(date) +
                this.conver(h) +
                this.conver(m) +
                this.conver(s) +
                "_";
            return now;
        },
        conver(s) {
            return s < 10 ? "0" + s : s;
        },
        editFile() {
            window.open(`${window.location.origin + process.env.BASE_URL}file/editor?id=${this.$route.query.cid}`)
        }
    },
    watch: {
        downStc() {
            this.fileNameHz = this.$route.query.name.split(".").pop();
            this.todownStc = this.downStc;
            this.oldList = this.old;
        }
    }
};
</script>

<style lang="scss" scoped>
.file-name {
    display: flex;
    justify-content: space-between;
}

.add-wjj {
    width: 200px;
    height: 45px;
    line-height: 45px;
    margin: 0 auto 10px;
    text-align: center;
    background: #0a2240;
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
}

.other-set {
    width: 200px;
    height: 40px;
    padding: 0 15px;
    line-height: 40px;
    margin: 20px auto;
    text-align: left;
    color: #0a2240;
    cursor: pointer;
    position: relative;
    background: #fff;
    border-radius: 20px;

    i {
        padding-right: 5px;
    }

    &:hover {
        color: #475ab5;
    }
}

.jiange {
    border-bottom: 1px solid #ddd;
    margin: 20px 0 10px;
}

.old-list {
    li {
        line-height: 30px;
        margin-bottom: 10px;
        border-bottom: 1px solid #ddd;

        span {
            padding-right: 40px;
            color: #999;
        }

        a {
            color: #0a2240;
        }
    }
}
</style>
